import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Plus, Minus } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: t.faq.q1,
    a: t.faq.a1
  }, {
    q: t.faq.q2,
    a: t.faq.a2
  }, {
    q: t.faq.q3,
    a: t.faq.a3
  }, {
    q: t.faq.q4,
    a: t.faq.a4
  }];
  return <section className="py-32 bg-warm-50 dark:bg-black transition-colors duration-300" data-id="element-74">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="text-center mb-16" data-id="element-76">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-77">
            {t.faq.title}
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400" data-id="element-78">
            {t.faq.subtitle}
          </p>
        </div>

        <div className="space-y-4" data-id="element-79">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 dark:border-dark-border rounded-2xl bg-white dark:bg-dark-card overflow-hidden transition-colors duration-300" data-id="element-80">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-81">
                <span className="font-bold text-lg text-gray-900 dark:text-white" data-id="element-82">
                  {faq.q}
                </span>
                <div className={`p-2 rounded-full ${openIndex === index ? 'bg-accent-blue text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'} transition-colors`} data-id="element-83">
                  {openIndex === index ? <Minus className="w-4 h-4" data-id="element-84" /> : <Plus className="w-4 h-4" data-id="element-85" />}
                </div>
              </button>

              <AnimatePresence data-id="element-86">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-87">
                    <div className="px-6 pb-6 text-gray-600 dark:text-gray-400 leading-relaxed" data-id="element-88">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}